import { render, staticRenderFns } from "./lianhou.vue?vue&type=template&id=cb45d93c&scoped=true"
import script from "./lianhou.vue?vue&type=script&lang=js"
export * from "./lianhou.vue?vue&type=script&lang=js"
import style0 from "./lianhou.vue?vue&type=style&index=0&id=cb45d93c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb45d93c",
  null
  
)

export default component.exports